import { useField } from "formik";
import { useCallback } from "react";

import { type KeyCombination } from "@skilitics/interact-keyboard";

import { KeyCapture, type KeyCaptureProps } from "../../keyboard/capture";
import { useFieldContext } from "../FormFieldContext";
import { useCommitChange } from "./helpers";

export const FieldKeyCapture = ({ disabled }: Pick<KeyCaptureProps, "disabled">) => {
  const commitChange = useCommitChange();

  const { name, dataTest } = useFieldContext();
  const [{ value }, _, { setValue, setError }] = useField<KeyCombination | undefined>(name);

  const handleChange = useCallback(
    (combination?: KeyCombination) => {
      setValue(combination)
        .then(commitChange)
        .catch((error) => {
          setError(error);
          console.warn(error);
        });
    },
    [commitChange, setError, setValue],
  );

  return <KeyCapture value={value} disabled={disabled} onChange={handleChange} data-test={dataTest} />;
};
